import { useQueryClient } from '@tanstack/react-query'
import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateMember from '@/modules/manage-member/api/hooks/useMutateUpdateMember'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import { useIsCurrentUser } from '@/modules/manage-member/hooks/useIsCurrentUser'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

interface IsActiveMemberProps {
	row: GetOperatorMemberListTableData
}

export function IsActiveMember({ row }: IsActiveMemberProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateMember } = useMutationUpdateMember()
	const isCurrentUser = useIsCurrentUser(row.id)

	if (isCurrentUser) {
		return null
	}

	const handleMutate = async (value: boolean) => {
		await updateMember({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [OperatorQueryKeys.GetMemberList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isActive}
			onMutate={handleMutate}
			errorMessage="ไม่สามารถอัพเดทสถานะได้"
		/>
	)
}
